import { useNavigate } from "react-router-dom";

//project imports

import cnt from "../../services/definedConstant";
import { BOM } from "../../services/definedMethod";
import { store } from "../storeOf";
import Cookies from "js-cookie";

export const SignOutAction = () => {
  return () => {
    Cookies.remove("tfaToken", { path: "/" });
    store.dispatch({ type: cnt.SIGN_OUT });
    if (window?.DevtoolsSoftDetector) {
      window.DevtoolsSoftDetector.stop();
    }
  };
};
